export const consumableFr = {
  "Note": "Note",
  "Donner une note si vous voulez": "Donner une note si vous voulez",
  "Fournisseur": "Fournisseur",
  "Consommable": "Consommable",
  "Quantité": "Quantité",
  "Total BC": "Total BC",
  "Total Payé": "Total Payé",
  "BC": "BC",
  "Les bons de commandes": "Les bons de commandes",
  "Cacher": "Cacher",
  "Afficher": "Afficher",
  "Historique de paiements": "Historique de paiements",
  "Reference": "Reference",
  "List Consommable": "List Consommable",
  "Fournisseurs": "Fournisseurs",
  "Debut": "Debut",
  "Fin": "Fin",
  "Jour": "Jour",
  "Mois": "Mois",
  "Bon de commande": "Bon de commande",

  // Server Side 

  "Le consomable deja existe.": "Le consomable deja existe.",
  "Le nom du consomable est obligatoire !!": "Le nom du consomable est obligatoire !!",
  "Le montant est obligatoire": "Le montant est obligatoire",
  "Le fournisseur est obligatoire": "Le fournisseur est obligatoire",
  "Les donneés du bon de commande sont obligatoire.": "Les donneés du bon de commande sont obligatoire.",
  "Donner une date valide": "Donner une date valide",

  "Le Fournisseur deja existe": "Le Fournisseur deja existe",
  "Le nom du fournisseur est obligatoire": "Le nom du fournisseur est obligatoire",
  "Le Telephone du fournisseur est obligatoire": "Le Telephone du fournisseur est obligatoire",

  "Supprimer tous les bons de commandes de ce fournisseur, pour pouvoir le supprimer.": "Supprimer tous les bons de commandes de ce fournisseur, pour pouvoir le supprimer.",
  


}